export default "__VITE_ASSET__DSBjs$5T__"